export default __webpack_public_path__ + "static/media/tuzla-kart-footer-baskan.9332faf5.png";